const communities = {
  'Tergar International': 'Tergar International',
  'Tergar Community': 'Tergar Community'
}

export default communities;